function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.25 7.5L0 .625 3.438 3.75 5.624 0l2.188 3.75L11.25.625 10 7.5H1.25zM10 9.375c0 .375-.25.625-.625.625h-7.5c-.375 0-.625-.25-.625-.625V8.75H10v.625z",
  fill: "#F507F7"
})));